import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import FileDraggable from 'UI/components/molecules/FileDraggable';
import FileDropzone from 'UI/components/molecules/FileDropzone';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {string[]} [props.allowedExtensions]
 * @param {Object[]} [props.attachments]
 * @param {Object} props.category
 * @param {Object} [props.FileDraggableProps]
 * @param {string} [props.fileNameField]
 * @param {boolean} [props.layoutInColumns]
 * @param {Function} [props.onFileDelete]
 * @param {Function} [props.onFileMove]
 * @param {Function} [props.onUploadFiles]
 * @param {boolean} [props.readOnly]
 * @param {boolean} [props.showFileSize]
 * @param {boolean} [props.showItemDate]
 * @param {boolean} [props.showItemMenu]
 * @param {boolean} [props.viewItemOnClick]
 */
const CategoryCard = ({
  allowedExtensions,
  attachments,
  category,
  FileDraggableProps,
  fileNameField,
  layoutInColumns,
  onFileDelete,
  onFileMove,
  onUploadFiles,
  readOnly,
  showFileSize,
  showItemDate,
  showItemMenu,
  viewItemOnClick
}) => {
  const classes = useStyles();

  if (!category) return null;
  return (
    <Card
      className={layoutInColumns ? classes.columnContainer : classes.rowContainer}
      variant="outlined"
    >
      <CardContent>
        <div className={classes.headersContainer}>
          <Typography variant="subtitle1">{category.title}</Typography>
          <Typography variant="body2">
            Count: {category.files.length}
            {!category.multiple && ` / ${category.maxFiles}`}
          </Typography>
        </div>
        <Droppable droppableId={category.id.toString()}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={snapshot.isDraggingOver ? classes.fileListDragging : classes.fileList}
            >
              <List>
                {category.files.map((file, index) => (
                  <FileDraggable
                    key={file.id === 0 ? file[fileNameField] : file.id}
                    file={file}
                    fileNameField={fileNameField}
                    index={index}
                    onFileDelete={onFileDelete}
                    onFileMove={onFileMove}
                    readOnly={readOnly}
                    showFileSize={showFileSize}
                    showItemDate={showItemDate}
                    showItemMenu={showItemMenu}
                    viewItemOnClick={viewItemOnClick}
                    {...FileDraggableProps}
                  />
                ))}
              </List>

              {provided.placeholder}
            </div>
          )}
        </Droppable>
        {!readOnly && (
          <FileDropzone
            allowedExtensions={allowedExtensions}
            attachments={attachments}
            categoryId={category.id}
            fileNameField={fileNameField}
            filesCount={category.files.length}
            maxFiles={category.maxFiles}
            multiple={!!category.multiple}
            onUploadFiles={onUploadFiles}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default CategoryCard;
